/**
 * Returns true when the given month index (0-11) is inside the provided list of
 * active season months (e.g. `['Jun', 'Jul', 'Aug']`). Returns false for null
 * months, null season lists, and months outside any season.
 *
 * Uses a fixed locale (`en-US`, short month) to avoid locale-dependent
 * mismatches, then normalizes both sides for comparison.
 */
export const isMonthSeasonActive = (
	month?: number | null,
	activeSeasonMonths?: string[] | null,
): boolean => {
	if (month === null || month === undefined || !activeSeasonMonths)
		return false;

	const date = new Date(0, month, 1);
	const monthLabel = date.toLocaleString('en-US', { month: 'short' });
	const normalizeMonth = (value: string): string =>
		value.slice(0, 3).toLowerCase();
	const normalizedMonthLabel = normalizeMonth(monthLabel);

	return activeSeasonMonths.some(
		(seasonMonth) => normalizeMonth(seasonMonth) === normalizedMonthLabel,
	);
};
